import { Injectable } from '@angular/core';
import { Component, OnInit, Inject, ViewChild, ElementRef, ChangeDetectionStrategy, Input, ChangeDetectorRef } from '@angular/core';
import { Observable, empty, forkJoin } from 'rxjs';
import { map, debounceTime, finalize, switchMap, tap, startWith, filter, mergeMap } from 'rxjs/operators';
import { API, APIDefinition, Columns, Config, DefaultConfig } from 'ngx-easy-table';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormBuilder, FormGroup, FormControl, ReactiveFormsModule } from '@angular/forms';
import { MatRipple } from '@angular/material/core';
import { MessagerComponent } from '../../messager/messager/messager.component';

import {MatDatepickerInputEvent} from '@angular/material/datepicker';
import { AuthService } from '../../auth.service';
import { LoggingService } from '../../utils/logging.service';
import { ScheduleService } from '../../schedule/schedule.service';
import { io } from 'socket.io-client';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';


//Font Awesome Icons
import { faEdit } from '@fortawesome/free-solid-svg-icons';
import { faTrashAlt } from '@fortawesome/free-solid-svg-icons';
import { faFileImport } from '@fortawesome/free-solid-svg-icons';
import { faHome } from '@fortawesome/free-solid-svg-icons';
import { faCamera } from '@fortawesome/free-solid-svg-icons';
import { faHardHat } from '@fortawesome/free-solid-svg-icons';
import { faGoogle } from '@fortawesome/free-brands-svg-icons';
import { faEnvelope } from '@fortawesome/free-solid-svg-icons';
import { faClipboard } from '@fortawesome/free-solid-svg-icons';
import { faCheckSquare } from '@fortawesome/free-solid-svg-icons';
import { faFile } from '@fortawesome/free-solid-svg-icons';
import { faCopy } from '@fortawesome/free-solid-svg-icons';
import { faLeaf } from '@fortawesome/free-solid-svg-icons';
import { faPaperclip } from '@fortawesome/free-solid-svg-icons';
//import { GlobalEmailService } from '../../../utils/globalemail.service';
import { MatSnackBar } from "@angular/material";
import { ContactUsService } from './contactus.service';


@Component({
  selector: 'app-contactus',
  templateUrl: './contactus.component.html',
  styleUrls: ['./contactus.component.css']
})
export class ContactUsComponent implements OnInit {
  constructor(public dialogRef: MatDialogRef<ContactUsComponent>,private snackBar: MatSnackBar, @Inject(MAT_DIALOG_DATA) public data: any, private fb:FormBuilder, public service: ContactUsService, private messager: MessagerComponent) {}

  content;

  ngOnInit(){



    //load RH plan data//
  }


  sendEmail(): void {

    let input = <HTMLInputElement>document.getElementById('content');
    let val = input.value;
    let frominput = <HTMLInputElement>document.getElementById('from');
    let fromval = frominput.value;
    let nameinput = <HTMLInputElement>document.getElementById('name');
    let nameval = nameinput.value;

    var obj = {
      content : val,
      from : fromval,
      name : nameval
    }

    console.log(obj);

    this.service.sendContactEmail(obj).subscribe(
      (res)=> {
        this.snackBar.open(`Email sent! Support will reach out to you momentarily`, "", {duration: 2000});
        this.dialogRef.close();
      }, err=> {
        this.snackBar.open(`Email not sent: ` + err.Message, "", {duration: 2000});
      }
    );

  }


}
